import { customerApi } from "../../utils/apiConfig";

const getAuthHeaders = () => ({
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  },
});

/**
 * NAVLUN FİRMA ROUTE'LARI
 */

export const createFreightCompany = (data) => {
  return customerApi.post("/navlun/company/create", data, getAuthHeaders());
};

export const updateFreightCompany = (data) => {
  return customerApi.post("/navlun/company/update", data, getAuthHeaders());
};

export const getFreightCompanyList = (page = 1, limit = 50) => {
  return customerApi.get(
    `/navlun/company/list/${page}/${limit}`,
    getAuthHeaders()
  );
};

export const deleteFreightCompany = (id) => {
  return customerApi.post("/navlun/company/delete", { id }, getAuthHeaders());
};

/**
 * NAVLUN TEKLİF TALEBİ ROUTE'LARI
 */

export const createFreightRequest = (data) => {
  return customerApi.post("/navlun/request/create", data, getAuthHeaders());
};

export const updateFreightRequest = (data) => {
  return customerApi.post("/navlun/request/update", data, getAuthHeaders());
};

export const getFreightRequestList = (page = 1, limit = 50) => {
  return customerApi.get(
    `/navlun/request/list/${page}/${limit}`,
    getAuthHeaders()
  );
};

export const getFreightRequestDetail = (id) => {
  return customerApi.get(`/navlun/request/detail/${id}`, getAuthHeaders());
};

/**
 * GOOGLE FORM ROUTE'LARI
 */

export const createFreightGoogleForm = (id) => {
  return customerApi.post(
    "/navlun/request/create-google-form",
    { id },
    getAuthHeaders()
  );
};

export const syncFreightGoogleResponses = (id) => {
  return customerApi.post(
    "/navlun/request/sync-google-responses",
    { id },
    getAuthHeaders()
  );
};

/**
 * NAVLUN ANALİZ ROUTE'LARI
 */

export const getFreightAnalysis = (
  page = 1,
  limit = 100,
  currency = "USD",
  requestId = ""
) => {
  const query = requestId ? `?requestId=${requestId}` : "";

  return customerApi.get(
    `/navlun/analysis/${page}/${limit}/${currency}${query}`,
    getAuthHeaders()
  );
};

export const getFreightYearCompare = (data = {}) => {
  return customerApi.post("/navlun/year-compare", data, getAuthHeaders());
};

export const sendFreightRequestMail = (id) => {
  return customerApi.post(
    "/navlun/request/send-mail",
    { id },
    getAuthHeaders()
  );
};
